[
  {
    "index": 0,
    "language": "English",
    "code": "en",
    "id": "92f37703-c9af-4585-b45c-cae1ed909c30",
    "resource_name": "admin_global_english",
    "name": "",
    "supportsCase": true
  },
  {
    "index": 1,
    "language": "Turkish",
    "code": "tr",
    "id": "14865368-367c-405a-9cc3-f5beff5c7882",
    "resource_name": "admin_global_turkish",
    "name": "",
    "supportsCase": true
  },
  {
    "index": 2,
    "language": "Russian",
    "code": "ru",
    "id": "ab4db36b-bfbe-4023-ad8a-742da0621e45",
    "resource_name": "admin_global_russian",
    "name": "",
    "supportsCase": true
  },
  {
    "index": 3,
    "language": "Portuguese",
    "code": "pt",
    "id": "789c4b94-6f9e-45fb-8605-cc7f1d433af2",
    "resource_name": "admin_global_portuguese",
    "name": "",
    "supportsCase": true
  },
  {
    "index": 4,
    "language": "Thai",
    "code": "th",
    "id": "cf41d373-284c-446f-b340-d9a5340acfa8",
    "resource_name": "admin_global_thai",
    "name": "",
    "supportsCase": false
  },
  {
    "index": 5,
    "language": "Indonesian",
    "code": "id",
    "id": "fab5564a-1d2c-4ce5-97df-114d93e25ab9",
    "resource_name": "admin_global_indonesian",
    "name": "",
    "supportsCase": true
  },
  {
    "index": 6,
    "language": "German",
    "code": "de",
    "id": "61d3e870-c6eb-4f92-a1c3-4018bf7edf63",
    "resource_name": "admin_global_german",
    "name": "",
    "supportsCase": true
  },
  {
    "index": 7,
    "language": "French",
    "code": "fr",
    "id": "f7dadb6d-bb0b-4f31-8f73-38881b9a2535",
    "resource_name": "admin_global_french",
    "name": "",
    "supportsCase": true
  },
  {
    "index": 8,
    "language": "Polish",
    "code": "pl",
    "id": "b8254eca-7495-4072-b487-74d903361db7",
    "resource_name": "admin_global_polish",
    "name": "",
    "supportsCase": true
  }
]
